<template>
    <Teleport to="body">
        <!-- Dimmer with fade transition -->
        <transition name="fade">
            <div v-if="isOpen" class="dimmer" @click="closeSidebar"></div>
        </transition>
        <!-- Sidebar with slide transition -->
        <transition name="slide">
            <div
                v-if="isOpen"
                class="sidebar h-full w-[600px] max-w-[85%] bg-white fixed top-0 right-0 z-[999999] shadow-2xl"
            >
                <div class="h-full w-full overflow-y-auto">
                    <button
                        @click.prevent="handleClose"
                        class="absolute top-2 -left-10 md:-left-15 text-white! z-50 cursor-pointer p-2"
                    >
                        <div class="h-5 w-5 md:h-8 md:w-8 text-white">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                class="w-full h-full object-cover"
                                viewBox="0 0 448 512"
                            >
                                <path
                                    d="M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"
                                />
                            </svg>
                        </div>
                    </button>
                    <slot></slot>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script setup>
import { computed } from "vue";
import usePublicStore from "@stores/publicStore";

const props = defineProps({
    name: {
        type: String,
    },
});

const publicStore = usePublicStore();
const isOpen = computed(() => publicStore.sidebarOpen === props.name);
const handleClose = () => {
    publicStore.toggleSidebar();
};

function closeSidebar() {
    publicStore.sidebarOpen = null;
}
</script>

<style scoped>
/* Fade transition for dimmer */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}

/* Slide transition for sidebar */
.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}
.slide-enter-from,
.slide-leave-to {
    transform: translateX(100%);
}
.slide-enter-to,
.slide-leave-from {
    transform: translateX(0);
}

/* Dimmer styles */
.dimmer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.65);
    z-index: 999998; /* behind the sidebar */
}
</style>
